<template>
    <div class="review-item">
        <div class="review-header flex items-center mb-spc15">
            <div class="left mr-6">
                <img :src="review.img" alt="Reviewer">
            </div>
            <div class="right">
                <h2 class="text-base opacity-75 mb-spc14">
                    {{review.name}}
                </h2>
                <ul class="stars flex items-center">
                    <li v-for="(icon, i) in review.rating" :key="i" class="text-primary mr-spc13">
                        <font-awesome-icon :icon="['fa', 'star']" />
                    </li>
                </ul>
            </div>
        </div>
        <div class="review-footer">
            <p class="whitespace-pre-line text-base opacity-50 max-w-300px">
                {{review.content}}
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ReviewItems",
        props: ['review']
    }
</script>

<style scoped>

</style>